import { toast } from "react-toastify"

import { Button, ToastContent } from "~/components/design-system/components"

/** A success toast whose Undo puts the change back. */
export function showUndoToast(title: string, onUndo: () => void) {
  toast.success(
    ({ closeToast }) => (
      <div className="flex items-center gap-3">
        <div className="flex-1">
          <ToastContent title={title} />
        </div>
        <Button
          variant="transparent"
          size="sm"
          requires="edit"
          onClick={() => {
            closeToast()
            onUndo()
          }}
        >
          Undo
        </Button>
      </div>
    ),
    // The Undo button takes the close button's corner.
    { closeButton: false, autoClose: 10_000 },
  )
}
